import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { DateRange, MultiSelect } from '@Components/Filters';

import {
  getCompaniesDictSelector,
  getCostCenterTypeDict,
  getCurrencies,
  getMrForDict,
  getWarrantyTypeDict,
} from '@Store/selectors/dictionarySelector';
import { FilterForm } from './types';
import {
  getStatusLabels,
  materialCostCenters,
} from '../store/selectors/materialRequestSelector';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const currentMaterialCostCenters = useAppSelector(materialCostCenters);
  const statuses = useAppSelector(getStatusLabels);
  const companies = useAppSelector(getCompaniesDictSelector);
  const costCenterTypes = useAppSelector(getCostCenterTypeDict);
  const warrantyTypes = useAppSelector(getWarrantyTypeDict);
  const mrForTypes = useAppSelector(getMrForDict);
  const currencies = useAppSelector(getCurrencies);
  const warrantyTypesLabels = warrantyTypes.map(
    (warrantyTypeItem) => warrantyTypeItem.codeDesc
  );
  const mrForTypesLabels = mrForTypes.map(
    (mrForTypeItem) => mrForTypeItem.codeDesc
  );
  const costCenterTypeLabels = costCenterTypes.map((ccItem) => ccItem.codeDesc);
  const companiesTypeLabels = companies.map((company) => company.compName);
  const currenciesLabels = currencies.map(
    (currencyItem) => currencyItem.currencyCode
  );
  const costCenterLabels = currentMaterialCostCenters.map(
    (cCenters) => cCenters.name
  );

  const items: CollapseProps['items'] = [
    {
      id: 'DATE RANGE',
      label: 'Date Range',
      children: (
        <DateRange<FilterForm>
          formik={formik}
          fromKey="dateFrom"
          toKey="dateTo"
        />
      ),
    },
    {
      id: 'CURRENCIES',
      label: 'Currencies',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="currencies"
          options={currenciesLabels}
        />
      ),
    },
    {
      id: 'COMPANIES',
      label: 'Companies',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="companies"
          options={companiesTypeLabels}
          showSearch
        />
      ),
    },
    {
      id: 'MRFOR',
      label: 'Mr For',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="mrFor"
          options={mrForTypesLabels}
        />
      ),
    },
    {
      id: 'COSTCENTERTYPE',
      label: 'Cost Center Type',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="ccTypes"
          options={costCenterTypeLabels}
        />
      ),
    },
    {
      id: 'COSTCENTER',
      label: 'Cost Center',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="cCenters"
          options={costCenterLabels}
          showSearch
        />
      ),
    },
    {
      id: 'WARRANTY',
      label: 'Warranty Type',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="warranties"
          options={warrantyTypesLabels}
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="statuses"
          options={statuses}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
